import { render } from "./AdBudgetAutoAdjust.vue?vue&type=template&id=e35b7e44&scoped=true"
import script from "./AdBudgetAutoAdjust.vue?vue&type=script&lang=js"
export * from "./AdBudgetAutoAdjust.vue?vue&type=script&lang=js"

import "./AdBudgetAutoAdjust.vue?vue&type=style&index=0&id=e35b7e44&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35b7e44"]])

export default __exports__